var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolaris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 29 41",
    height: "201px",
    width: "201px",
    style: {
      height: "100%",
      width: "100%",
      background: "none",
      shapeRendering: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(0.83, 0.83)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "14.5px 20.5px",
      transform: "scale(0.76)",
      animation: "2.32558s linear 0s infinite normal forwards running breath-7120706f-fe28-42b4-98a1-22733a5787bc"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0.805664 20.2886C9.25901 20.2886 14.5 20.2886 14.5 0.3125C14.5 20.2886 20.6312 20.2886 28.1943 20.2886C14.5 20.2886 14.5 29.2322 14.5 40.2646C14.5 20.2886 8.36884 20.2886 0.805664 20.2886Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "breath-7120706f-fe28-42b4-98a1-22733a5787bc",
    "data-anikit": ""
  }, "@keyframes breath-7120706f-fe28-42b4-98a1-22733a5787bc\n{\n  0% {\n    animation-timing-function: cubic-bezier(1.1955,0.1733,-0.2633,0.8547);\n    transform: scale(0.76);\n  }\n  51% {\n    animation-timing-function: cubic-bezier(1.1832,0.1982,-0.2661,0.8322);\n    transform: scale(1.18);\n  }\n  100% {\n    transform: scale(0.76);\n  }\n}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolaris);
export default __webpack_public_path__ + "static/media/polaris.ecf77e59e2828a0a98ab66bdaba4c581.svg";
export { ForwardRef as ReactComponent };